import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcTab } from '@one/react';

export type PocTabProps = ComponentPropsWithoutRef<typeof OwcTab>;

export const PocTab = forwardRef<ElementRef<typeof OwcTab>, PocTabProps>((props, ref) => (
    <OwcTab ref={ref} {...props} />
));

PocTab.displayName = 'PocTab';
